module.exports = __webpack_public_path__ + "static/media/gnatta-logo-horizontal-colour.3d5ce86a.svg";